export const userData =  ({store})  => store.userReducer.user;
export const userCsrf =  ({store})  => store.userReducer.csrf;

export const updatedUserData = ({store}) =>store.updateUserReducer.data;
export const updatedUserLoader = ({store}) =>store.updateUserReducer.loading;
export const updatedUserError = ({store}) =>store.updateUserReducer.error;